export function getBookmarkLink({ bookmark, baseUrl }) {
    const document = bookmark.document;

    if (bookmark.excel) {
        return (
            `${baseUrl}/document/bookmarks/${document}` +
            `?excel=${JSON.stringify(bookmark.excel)}&bid=${bookmark?._id ?? ""}`
        );
    } else if (bookmark.areas?.length) {
        const area = bookmark.areas[0];
        let link = `${baseUrl}/document/bookmarks/${document}?area=${JSON.stringify(area)}`;

        if (bookmark?._id) {
            link += "&bid=" + bookmark._id;
        } else {
            link += "&focus=1";
        }

        return link;
    }
}
